<template>
  <div id="Header">
    <!-- <div class="topAdvertising1" v-if="$route.name == 'Home'">
      <img
        @click="handleLinkSite(bannerList[1])"
        v-if="bannerList[1]"
        class="head_img"
        :src="qiniuUrl+bannerList[1].imgUrl"
      />
    </div>
    <div class="notice">
      <div class="noticeMain">
        <marquee
          scrollamount="5"
          onmouseover="this.stop();"
          onmouseout="this.start();"
        >{{bulletinContent}}</marquee>
      </div>
    </div> -->
    <div class="topHandle">
      <ul class="topHandleMain">
        <li @click="handleIndex">设为首页</li>
        <li @click="handleSave">收藏本站</li>
      </ul>
    </div>
    <!-- <div class="topAdvertising2">
      <img
        @click="handleLinkSite(bannerList[2])"
        v-if="bannerList[2]"
        class="head_img"
        :src="qiniuUrl+bannerList[2].imgUrl"
      />
    </div> -->
    <!-- <div class="menu">
      <ul :class="device=='mobile'?'mobile menubox' :'menubox'">
        <li :class="{'active':$route.name == 'Home'}" @click="$router.push('/')">首页</li> -->
        <!-- <li>首页</li> -->
        <!-- <li class="lobby">
          <span>
            彩票大厅
            <em></em>
          </span>
          <div class="lobbycon">
            <ul class="lobbyconMain">
              <li>
                <div class="title">
                  <img src="../../assets/img/hot.png" alt />
                  <p>热门彩</p>
                </div>
                <div class="games">
                  <div>
                    <span v-for="(it,i) in hotGame" :key="i" @click="goto(it)">{{it.memo}}</span>
                  </div>
                </div>
              </li>
              <li v-for="(it,i) in allGameBetTypeList" :key="i">
                <div class="title">
                  <img src="../../assets/img/hot.png" alt />
                  <p>{{BET_TYPE_NAME[i]}}</p>
                </div>
                <div class="games">
                  <div>
                    <!-- <span v-for="(is,j) in it" :key="j" @click="goto(is)">{{is.gameName}}</span> -->
                    <!-- <span v-for="(is,j) in it" :key="j" @click="goto(is)">{{is.memo}}</span>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </li> -->
        <!-- <li :class="{'active':$route.name == 'GameList'}" @click="$router.push('/GameList')">走势图表</li>
        <li @click="deving">稳赢计划</li>
        <li @click="deving">长龙提醒</li> -->
      <!-- </ul> -->
    <!-- </div> -->
    <div :class="device=='mobile'?'mobile-goback':'goback'" v-if="showGoBack" @click="goback"></div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { BET_TYPE_NAME } from "../../helpers/BETTYPEDATA.js";

const host = window.location.host;
export default {
  name: "Header",
  data() {
    return {
      showGoBack: false,
      host,
      BET_TYPE_NAME
    };
  },
  computed: {
    ...mapState([
      "hotGame",
      "BETTYPENAME",
      "allGame",
      "device",
      "bannerList",
      "bulletinContent",
      "qiniuUrl"
    ]),
    ...mapGetters(["allGameBetTypeList"])
  },
  mounted() {
    this.countScroll();
  },
  methods: {
    handleIndex() {
      alert(
        "您好,您的浏览器不支持自动设置页面为首页功能,请您手动在浏览器里设置该页面为首页!"
      );
    },
    handleSave() {
      alert("您的浏览器不支持,请按 Ctrl+D 手动收藏!");
    },
    countScroll() {
      window.onscroll = () => {
        if (window.pageYOffset >= 200) {
          this.showGoBack = true;
        } else {
          this.showGoBack = false;
        }
      };
    },
    goback() {
      const scrollToTop = () => {
        const c = document.documentElement.scrollTop || document.body.scrollTop;
        if (c > 0) {
          window.requestAnimationFrame(scrollToTop);
          window.scrollTo(0, c - c / 8);
        }
      };
      scrollToTop();
    },
    deving() {
      alert("功能开发中");
    },
    goto(is) {
      // this.$router.push(`/Trend/${is.type}/${is.gameType}`);
      window.location.href = `/Trend/${is.type}/${is.gameType}`;
    },
    handleLinkSite(data) {
      if (data.isTurn == 1) {
        window.open(data.url, "_blank");
      } else {
        return;
      }
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
@media screen and (max-width: 1200px) {
  #Header {
    .head_img,
    .noticeMain,
    .topHandleMain,
    .menubox,
    .lobbyconMain {
      width: 100% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header/index.vue